<template>
  <div class="export-csv">
    <button @click="handleExport" :disabled="loading || disabled" class="export-button">
      {{ loading ? '正在导出...' : buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ExportCSV',
  props: {
    // 订单信息
    orderInfo: {
      type: Object,
      required: true,
      default: () => ({})
    },
    // 按分类分组的物品列表
    itemsByCategory: {
      type: Object,
      required: true,
      default: () => ({})
    },
    // 总金额
    totalAmount: {
      type: Number,
      default: 0
    },
    // 总物品数量
    totalItemsCount: {
      type: Number,
      default: 0
    },
    // 按钮文本
    buttonText: {
      type: String,
      default: '导出清单'
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 文件名前缀
    fileNamePrefix: {
      type: String,
      default: '设备清单'
    },
    // 自定义标题行
    headers: {
      type: Array,
      default: () => ['序号', '分类', '设备名称', '规格', '单价(元/天)', '数量', '天数', '小计(元)']
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    },

    // 处理导出
    handleExport() {
      if (this.disabled || this.loading) {
        return;
      }

      // 检查是否有可导出的内容
      const hasItems = Object.values(this.itemsByCategory).some(items => items && items.length > 0);
      if (!hasItems) {
        this.$message.warning('没有可导出的内容');
        return;
      }

      this.loading = true;

      try {
        // 准备数据行
        let rows = [this.headers.join(',')]; // 添加标题行

        // 添加数据行 - 按分类分组导出
        let serialNumber = 1;
        Object.entries(this.itemsByCategory).forEach(([categoryName, items]) => {
          if (items && items.length > 0) {
            items.forEach(item => {
              const rentalDays = this.orderInfo.rental_days || 0;
              const subtotal = (item.price * item.quantity * rentalDays).toFixed(2);

              // 构建行数据，处理可能包含逗号的值
              const row = [
                serialNumber++,
                this.escapeCsvField(categoryName),
                this.escapeCsvField(item.name),
                this.escapeCsvField(item.spec_text || ''),
                item.price,
                item.quantity,
                rentalDays,
                subtotal
              ];

              rows.push(row.join(','));
            });
          }
        });

        // 添加总计信息
        rows.push(''); // 空行分隔
        rows.push(['', '', '', '', '', '设备总数', '', `${this.totalItemsCount} 件`].join(','));
        rows.push(['', '', '', '', '', '预估天数', '', `${this.orderInfo.rental_days || 0} 天`].join(','));
        rows.push(['', '', '', '', '', '总计金额', '', `¥${this.totalAmount.toFixed(2)}`].join(','));

        // 生成CSV内容，添加BOM以支持中文
        const csvContent = '\uFEFF' + rows.join('\n');

        // 创建Blob对象
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

        // 创建下载链接
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        // 生成文件名
        const orderNumber = this.orderInfo.order_number || '预订单';
        const dateStr = this.formatDate(new Date());
        const fileName = `${this.fileNamePrefix}_${orderNumber}_${dateStr}.csv`;

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        // 添加到文档并触发下载
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 释放URL对象
        URL.revokeObjectURL(url);

        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.loading = false;
      }
    },

    // 转义CSV字段，处理包含逗号、引号或换行符的值
    escapeCsvField(field) {
      const fieldStr = String(field || '');
      // 如果字段包含逗号、引号或换行符，则需要用引号包裹并转义内部引号
      if (fieldStr.includes(',') || fieldStr.includes('"') || fieldStr.includes('\n') || fieldStr.includes('\r')) {
        return `"${fieldStr.replace(/"/g, '""')}"`;
      }
      return fieldStr;
    }
  }
};
</script>

<style scoped>
.export-button {
  padding: 4px 12px;
  background-color: #67c23a;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-left: 8px;
}

.export-button:hover:not(:disabled) {
  background-color: #85ce61;
}

.export-button:disabled {
  background-color: #c0c4cc;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/ExportCSV.vue